import { useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Layout from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useAdminBotChatConversationsQuery } from "@/generated/graphql";
import { ConversationView } from "@/components/admin/ConversationView";

const AdminUserBotConversations = () => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const [activeId, setActiveId] = useState<string | null>(null);

  const { data, loading } = useAdminBotChatConversationsQuery({
    variables: { userId: id, pageSize: 100 },
    skip: !id,
  });

  const conversations = data?.adminBotChatConversations?.data || [];
  const active = conversations.find((c) => c.id === activeId) || conversations[0];

  return (
    <Layout>
      <main className="flex-1 p-4 sm:p-6 lg:p-8 overflow-y-auto">
        <div className="max-w-5xl mx-auto space-y-6">
          <Link to={`/admin/users/${id}`}>
            <Button variant="ghost" size="sm">
              <ArrowLeft className="w-4 h-4 mr-1" />
              {t("admin.botConversations.backToUser")}
            </Button>
          </Link>

          <h1 className="text-2xl font-bold">{t("admin.botConversations.perUserTitle")}</h1>

          {loading && !data ? (
            <div className="flex items-center justify-center py-12">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
            </div>
          ) : conversations.length === 0 ? (
            <p className="text-muted-foreground py-8 text-center">
              {t("admin.botConversations.userNoConversations")}
            </p>
          ) : (
            <>
              {conversations.length > 1 && (
                <div className="flex gap-2">
                  {conversations.map((c) => (
                    <Button
                      key={c.id}
                      variant={active?.id === c.id ? "default" : "outline"}
                      size="sm"
                      className="capitalize"
                      onClick={() => setActiveId(c.id)}
                    >
                      {c.channel}
                    </Button>
                  ))}
                </div>
              )}
              {active && <ConversationView key={active.id} conversationId={active.id} />}
            </>
          )}
        </div>
      </main>
    </Layout>
  );
};

export default AdminUserBotConversations;
